// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lb37q","footer":"styles_footer__2uBl_","passCodeTooltip":"styles_passCodeTooltip__38R3v"};